import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import ProductPage from "./Pages/ProductPage";
import AboutPage from "./Pages/AboutPage";
import ContactPage from "./Pages/ContactPage";
import CareerPage from "./Pages/CareerPage";
import BePartnerPage from "./Pages/BePartnerPage";
import AdminLoginPage from "./Pages/AdminLoginPage";
import AdminDashboard from "./AdminDasboard/AdminDashboard";
import ContactPerson from "./AdminDasboard/ContactPerson";
import Pharmasist from "./AdminDasboard/Pharmasist";
import Accountant from "./AdminDasboard/Accountant";
import WareHouseManger from "./AdminDasboard/WareHouseManger";
import WareHouseExecutive from "./AdminDasboard/WareHouseExecutive";
import SalesExecutive from "./AdminDasboard/SalesExecutive";
import PageDoesNot from "./Home/PageDoesNot";

const AppRouter = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/product" element={<ProductPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/career" element={<CareerPage />} />
      <Route path="/be-partner" element={<BePartnerPage />} />
      <Route path="*" element={<PageDoesNot />} />

      {/* Admin Routes */}
      <Route path="/admin-login" element={<AdminLoginPage />} />
      <Route path="/admin-dashboard" element={<AdminDashboard />}>
        <Route path="contact-person" element={<ContactPerson />} />
        <Route path="pharmasist-form" element={<Pharmasist />} />
        <Route path="accountant-form" element={<Accountant />} />
        <Route path="warehouse-manger-form" element={<WareHouseManger />} />
        <Route path="warehouse-executive-form" element={<WareHouseExecutive />} />
        <Route path="sales-executive-form" element={<SalesExecutive />} />
      </Route>
    </Routes>
  );
};

export default AppRouter; // ✅ Correctly exported
